// extracted by mini-css-extract-plugin
export default {"cls1":"l5WT2vllB_tyvBZmZtcZ","cls2":"fVtcmVH_z3e7ZIPRgGjS l5WT2vllB_tyvBZmZtcZ"};